<script>
import styled from 'vue-styled-components';

const CookieBannerFooter = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 2rem 0;
`;

export default CookieBannerFooter;
</script>